import React, { useEffect } from 'react'
import { withParsedContext } from '../../Magazines/withJSSContext'
import { ChrComponent } from '../../../types'
import { isClient } from '@christies/react/utils'
import styled from 'styled-components'

interface Props {
  parsedFields: {
    headerModel: ChrComponent
    headerAuth: ChrComponent
    headerAssetsUrl: string
    headerCssUrl: string
  }
}

const HeaderZoneV2: React.FC<Props> = ({ parsedFields }) => {
  const legacyModel = parsedFields?.headerAuth
  const isAuth = parsedFields?.headerAuth?.data?.header?.is_authenticated
  const headerData = parsedFields.headerModel
  const assetsUrl = parsedFields.headerAssetsUrl

  if (isClient) {
    window.chrComponents = window.chrComponents || {}
    window.chrComponents.header = window.chrComponents.header || {}
    window.chrComponents.header.data = legacyModel?.data
    window.chrComponents.header.labels = legacyModel?.labels
  }

  useEffect(() => {
    const host = document.getElementById('headerHost')
    if (!host) return

    const shadowRoot = host.attachShadow({ mode: 'open' })

    const scriptEl = document.createElement('script')
    scriptEl.defer = true
    scriptEl.type = 'module'
    scriptEl.textContent = `
      import ReactTools, { Header, AuthContext } from "${assetsUrl}";

      const authParams = {
        login: () => { window.dispatchEvent(new CustomEvent("chr.openLoginModal")) },
        logout: () => { window.dispatchEvent(new CustomEvent("chr.logout")) },
        isAuthenticated: ${isAuth ?? false},
        getToken: () => "",
      };

      // Access shadow DOM elements
      const hostEl = document.getElementById("headerHost");
      const shadowRoot = hostEl.shadowRoot;
      const headerRootEl = shadowRoot.getElementById("headerRoot");

      if (headerRootEl) {
        const headerRoot = ReactTools.createRoot(headerRootEl);
        headerRoot.render(
          ReactTools.createElement(
            AuthContext.Provider, 
            { value: authParams }, 
            ReactTools.createElement(Header, {
              headerData: ${JSON.stringify(headerData)}
            })
          )
        );
      }
    `
    document.body.appendChild(scriptEl)

    const linkEl = document.createElement('link')
    linkEl.rel = 'stylesheet'
    linkEl.href = parsedFields.headerCssUrl
    shadowRoot.appendChild(linkEl)

    const styleEl = document.createElement('style')
    styleEl.textContent = `
      :root, :host(#headerHost), :host(#footerHost) {
        --z-index-base: 100;
      }
    `
    shadowRoot.appendChild(styleEl)

    const headerRootEl = document.createElement('div')
    headerRootEl.id = 'headerRoot'
    shadowRoot.appendChild(headerRootEl)

    return (): void => {
      if (document.body.contains(scriptEl)) {
        document.body.removeChild(scriptEl)
      }
    }
  }, [])

  if (!headerData || Object.keys(headerData).length === 0) return null

  return (
    <HeaderWrapper>
      <div id="headerHost" />
      <div className="chr-header-footer">
        <chr-modal-provider></chr-modal-provider>
      </div>
    </HeaderWrapper>
  )
}

export default withParsedContext(HeaderZoneV2 as React.FC)

// Prevent layout shift on the page
const HeaderWrapper = styled.div`
  min-height: 56px;

  @media (min-width: 1280px) {
    min-height: 94px;
  }
`
